import { render, staticRenderFns } from "./EditQuotes.vue?vue&type=template&id=4cab18a2"
import script from "./EditQuotes.vue?vue&type=script&lang=js"
export * from "./EditQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports